import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ZoneButton from './ZoneButton';
import ZoneButtonsWrapper from './ZoneButtonsWrapper';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../components/CardReader/CardReader';

const ButtonBCD = styled(ZoneButton)`
  height: 100%;
  margin-top: 2%;
  margin-left: 18%;
  width: 54%;
`;

const ButtonCD = styled(ZoneButton)`
  margin-left: 34%;
  width: 37%;
`;

const ButtonDummy = styled(ZoneButton)`
  margin-top: ${getRelativeHeight(-4)};
  width: 0;
`;

const UpButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 9%;
  right: ${getRelativeHeight(5)};
  height: ${getRelativeHeight(52)};
  width: ${getRelativeWidth(390)};
  margin-bottom: ${getRelativeHeight(7)};
`;

const UpButton = styled(ZoneButton)`
  height: ${getRelativeHeight(266)};
  width: ${getRelativeWidth(65)};
  cursor: pointer;
`;

const ZoneButtonsC2 = ({ onClickZoneBCD, onClickZoneCD, onClickUpButton }) => (
  <ZoneButtonsWrapper>
    <UpButtonWrapper>
      <ButtonBCD onClick={onClickZoneBCD} />
      <UpButton onClick={onClickUpButton} />
    </UpButtonWrapper>
    <ButtonCD onClick={onClickZoneCD} />
    <ButtonDummy onClick={() => false} />
  </ZoneButtonsWrapper>
);

ZoneButtonsC2.propTypes = {
  onClickZoneBCD: PropTypes.func.isRequired,
  onClickZoneCD: PropTypes.func.isRequired,
  onClickUpButton: PropTypes.func.isRequired,
};

export default ZoneButtonsC2;
